export class SaleOfferControlDocument {
  constructor(
      public hash?: string,
      public saleOfferHash?: string,
      public date?: number,
      public transportOperator?: string,
      public carrier?: string,
      public enrollment?: string,
      public trailer?: string,
      public observation?: string,
      public viewLogoInPdf?: string,
      public packingUnits?: number
  ) { }

  clone() {
    return new SaleOfferControlDocument(
        this.hash,
        this.saleOfferHash,
        this.date,
        this.transportOperator,
        this.carrier,
        this.enrollment,
        this.trailer,
        this.observation,
        this.viewLogoInPdf,
        this.packingUnits
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/sale-offer-control-document.ts